import { cn } from '@/lib/utils'

interface PanelHeaderProps extends Omit<React.ComponentProps<'header'>, 'title'> {
  leading?: React.ReactNode
  title: React.ReactNode
  actions?: React.ReactNode
}

/** 60px top bar shared by chat, pages and panels. */
function PanelHeader({ leading, title, actions, className, ...props }: PanelHeaderProps) {
  return (
    <header
      data-slot="panel-header"
      className={cn(
        'border-border/60 flex h-14 shrink-0 items-center gap-2.5 border-b px-4 md:h-[60px] md:px-5',
        className
      )}
      {...props}
    >
      {leading}
      <div className="min-w-0 flex-1 truncate text-base leading-none font-semibold">{title}</div>
      {actions && <div className="flex shrink-0 items-center gap-1">{actions}</div>}
    </header>
  )
}

export { PanelHeader }
